import { render, staticRenderFns } from "./InterconsultaModalView.vue?vue&type=template&id=d9f3c408"
import script from "./InterconsultaModalView.vue?vue&type=script&lang=js"
export * from "./InterconsultaModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports